<template>
    <student-backend-layout content-bg-color="gray-125">
        <template #content>
            <div
                class="mx-auto mb-24 flex w-full max-w-3xl flex-col gap-8 px-4"
            >
                <div class="mt-8 w-full">
                    <div class="text-[26px] font-semibold text-gray-825">
                        Account Settings
                    </div>
                </div>

                <StudentMembershipExpiredNotice
                    v-if="
                        user.subscription &&
                        user.subscription.status != 'active'
                    "
                />

                <StudentNoSubscriptionNotice v-if="!user.subscription" />

                <StudentAccountInformationForm :user="user" />

                <StudentChangeProviderLevelForm
                    :user="user"
                    v-if="user.subscription?.plan.type === 0"
                />

                <StudentSubscriptionManageWidget
                    v-if="user.subscription?.plan.type === 0"
                    :user="user"
                />

                <GroupStudentSubscriptionManageWidget
                    v-if="user.group_id"
                    :user="user"
                />

                <StudentChangePasswordForm />
            </div>
        </template>
    </student-backend-layout>
</template>

<script>
import StudentAccountInformationForm from "@/Pages/NewStudentBackend/StudentAccountInformationForm.vue";
import StudentChangeProviderLevelForm from "@/Pages/NewStudentBackend/StudentChangeProviderLevelForm.vue";
import StudentSubscriptionManageWidget from "@/Pages/NewStudentBackend/StudentSubscriptionManageWidget.vue";
import GroupStudentSubscriptionManageWidget from "@/Pages/NewStudentBackend/GroupStudentSubscriptionManageWidget.vue";
import StudentChangePasswordForm from "@/Pages/NewStudentBackend/StudentChangePasswordForm.vue";
import StudentMembershipExpiredNotice from "@/Pages/NewStudentBackend/StudentMembershipExpiredNotice.vue";
import StudentBackendLayout from "@/_Layouts/NewStudentBackendLayout.vue";
import StudentNoSubscriptionNotice from "@/Pages/NewStudentBackend/StudentNoSubscriptionNotice.vue";

export default {
    name: "StudentManageAccount",
    components: {
        StudentNoSubscriptionNotice,
        StudentMembershipExpiredNotice,
        StudentChangePasswordForm,
        StudentSubscriptionManageWidget,
        GroupStudentSubscriptionManageWidget,
        StudentChangeProviderLevelForm,
        StudentAccountInformationForm,
        StudentBackendLayout,
    },
    props: {
        user: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    methods: {},
};
</script>
